<button type="button" class="mbp-toggle" [class.mbp-toggle--on]="checked()" [disabled]="disabled()"
  [attr.aria-label]="ariaLabel() || null" (click)="onClick()">
  <span class="toggle-handle"></span>
</button>
